/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Footnote_CheckoutInputs */

const en_admin_funnel_footnote_checkout = /** @type {(inputs: Admin_Funnel_Footnote_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent to payment = the server created a payment session (/api/payment/checkout); provider is the one actually used.`)
};

/**
* | output |
* | --- |
* | "Sent to payment = the server created a payment session (/api/payment/checkout); provider is the one actually used." |
*
* @param {Admin_Funnel_Footnote_CheckoutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_footnote_checkout = /** @type {((inputs?: Admin_Funnel_Footnote_CheckoutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Footnote_CheckoutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_footnote_checkout(inputs)
});
export { admin_funnel_footnote_checkout as "admin.funnel.footnote.checkout" }